<template>
  <div class="application-items-grid">
    <div class="application-items-grid__grid" data-cy="apartments-to-apply">
      <div
        v-for="(item, index) in items"
        class="application-items-grid__item"
        :key="index"
      >
        <slot v-bind:item="item"/>
      </div>

      <!-- This forces items to be same width (as long as there are max. 2 columns) -->
      <div
        v-if="items.length % 2"
        class="application-items-grid__spacer"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";

  @mixin application-items-grid__column() {
    margin: r(5) r(4);

    @include media-breakpoint-up(sm) {
      flex: 1;
      min-width: r(300);
    }
  }

  .application-items-grid {
    @include prevent-margin-collapse;
  }

  .application-items-grid__grid {
    display: flex;
    flex-direction: column;
    margin: r(-5) r(-4);

    @include media-breakpoint-up(sm) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .application-items-grid__item {
    @include card;
    @include application-items-grid__column;
    overflow: hidden;
    background-color: $color-white;
  }

  .application-items-grid__spacer {
    @include application-items-grid__column;
    margin-top: 0;
    margin-bottom: 0;
  }
</style>
